module.exports = __webpack_public_path__ + "img/connect-your-apps.63230e56.png";